import {Fragment} from "react";

import {
    type IUseSearchComboboxResult,
    SearchComboboxDivider,
    SearchComboboxGroup,
    SearchComboboxMetrics,
    type SearchComboboxMode,
    SearchComboboxShowMore,
    SearchComboboxSubList,
    SearchComboboxSubOption
} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import type {IPricesSearchSection, IPricesSearchStreetItem} from "../../types/IPricesSearchModel";
import {getPricesSearchMetricLines, PricesSearchRow, PricesSearchUnavailableMetrics} from "./PricesSearchRow";

export interface IPricesSearchListProps {
    combobox: Pick<IUseSearchComboboxResult, "getOptionProps" | "getGroupLabelId">;
    mode: SearchComboboxMode;
    onRemoveRecent: (recentId: string) => void;
}

interface IProps extends IPricesSearchListProps {
    sections: readonly IPricesSearchSection[];
}

const PricesSearchStreetNumbers = (props: IPricesSearchListProps & {street: IPricesSearchStreetItem}) => {
    const {street, combobox} = props;
    const {numbers} = street;

    if (!numbers) {
        return null;
    }

    return (
        <SearchComboboxSubList label={numbers.label} dataTestId={PRICES_SEARCH_TEST_IDS.NUMBERS}>
            {numbers.items.map((number) => {
                // Transactions come with the search, the price is asked for lazily per rendered number. The columns are
                // aligned, so the prices of a street's numbers end on one line whatever their period's length.
                const {primary, primaryHint, secondary} = getPricesSearchMetricLines(number.metrics);
                const meta = number.isUnavailable ? (
                    <PricesSearchUnavailableMetrics layout="inline" alignColumns metrics={number.metrics} />
                ) : primary || secondary ? (
                    <SearchComboboxMetrics layout="inline" alignColumns primary={primary} primaryHint={primaryHint} secondary={secondary} />
                ) : undefined;

                return (
                    <SearchComboboxSubOption
                        key={number.id}
                        {...combobox.getOptionProps(number.id)}
                        title={number.title}
                        meta={meta}
                        dataTestId={PRICES_SEARCH_TEST_IDS.NUMBER}
                    />
                );
            })}
            {numbers.showMore ? (
                <SearchComboboxShowMore
                    {...combobox.getOptionProps(numbers.showMore.id)}
                    label={numbers.showMore.label}
                    isLoading={numbers.showMore.isLoading}
                    indent
                    dataTestId={PRICES_SEARCH_TEST_IDS.SHOW_MORE}
                />
            ) : null}
        </SearchComboboxSubList>
    );
};

/** Groups of rows in model order, a divider between consecutive groups. */
export const PricesSearchSectionList = (props: IProps) => {
    const {sections, combobox, mode, onRemoveRecent} = props;

    return (
        <>
            {sections.map((section, index) => (
                <Fragment key={section.kind}>
                    {index > 0 ? <SearchComboboxDivider /> : null}
                    <SearchComboboxGroup
                        title={section.title}
                        labelId={combobox.getGroupLabelId(section.kind)}
                        action={
                            section.action
                                ? {label: section.action.label, ...combobox.getOptionProps(section.action.id), dataTestId: PRICES_SEARCH_TEST_IDS.RECENT_CLEAR}
                                : undefined
                        }
                        dataTestId={PRICES_SEARCH_TEST_IDS.GROUP}
                    >
                        {section.items.map((item) => {
                            const {recentId} = item;

                            return (
                                <Fragment key={item.id}>
                                    <PricesSearchRow
                                        item={item}
                                        optionProps={combobox.getOptionProps(item.id)}
                                        mode={mode}
                                        onRemove={recentId === undefined ? undefined : () => onRemoveRecent(recentId)}
                                    />
                                    {item.kind === "street" ? <PricesSearchStreetNumbers {...props} street={item} /> : null}
                                </Fragment>
                            );
                        })}
                        {section.showMore ? (
                            <SearchComboboxShowMore
                                {...combobox.getOptionProps(section.showMore.id)}
                                label={section.showMore.label}
                                isLoading={section.showMore.isLoading}
                                dataTestId={PRICES_SEARCH_TEST_IDS.SHOW_MORE}
                            />
                        ) : null}
                    </SearchComboboxGroup>
                </Fragment>
            ))}
        </>
    );
};
import {Fragment} from "react";

import {
    type IUseSearchComboboxResult,
    SearchComboboxDivider,
    SearchComboboxGroup,
    SearchComboboxMetrics,
    type SearchComboboxMode,
    SearchComboboxShowMore,
    SearchComboboxSubList,
    SearchComboboxSubOption
} from "@pg-design/search-combobox-module";
import {PRICES_SEARCH_TEST_IDS} from "@pg-mono/test-ids";

import type {IPricesSearchSection, IPricesSearchStreetItem} from "../../types/IPricesSearchModel";
import {getPricesSearchMetricLines, PricesSearchRow, PricesSearchUnavailableMetrics} from "./PricesSearchRow";

export interface IPricesSearchListProps {
    combobox: Pick<IUseSearchComboboxResult, "getOptionProps" | "getGroupLabelId">;
    mode: SearchComboboxMode;
    onRemoveRecent: (recentId: string) => void;
}

interface IProps extends IPricesSearchListProps {
    sections: readonly IPricesSearchSection[];
}

const PricesSearchStreetNumbers = (props: IPricesSearchListProps & {street: IPricesSearchStreetItem}) => {
    const {street, combobox} = props;
    const {numbers} = street;

    if (!numbers) {
        return null;
    }

    return (
        <SearchComboboxSubList label={numbers.label} dataTestId={PRICES_SEARCH_TEST_IDS.NUMBERS}>
            {numbers.items.map((number) => {
                // Transactions come with the search, the price is asked for lazily per rendered number. The columns are
                // aligned, so the prices of a street's numbers end on one line whatever their period's length.
                const {primary, primaryHint, secondary} = getPricesSearchMetricLines(number.metrics);
                const meta = number.isUnavailable ? (
                    <PricesSearchUnavailableMetrics layout="inline" alignColumns metrics={number.metrics} />
                ) : primary || secondary ? (
                    <SearchComboboxMetrics layout="inline" alignColumns primary={primary} primaryHint={primaryHint} secondary={secondary} />
                ) : undefined;

                return (
                    <SearchComboboxSubOption
                        key={number.id}
                        {...combobox.getOptionProps(number.id)}
                        title={number.title}
                        meta={meta}
                        dataTestId={PRICES_SEARCH_TEST_IDS.NUMBER}
                    />
                );
            })}
            {numbers.showMore ? (
                <SearchComboboxShowMore
                    {...combobox.getOptionProps(numbers.showMore.id)}
                    label={numbers.showMore.label}
                    isLoading={numbers.showMore.isLoading}
                    indent
                    dataTestId={PRICES_SEARCH_TEST_IDS.SHOW_MORE}
                />
            ) : null}
        </SearchComboboxSubList>
    );
};

/** Groups of rows in model order, a divider between consecutive groups. */
export const PricesSearchSectionList = (props: IProps) => {
    const {sections, combobox, mode, onRemoveRecent} = props;

    return (
        <>
            {sections.map((section, index) => (
                <Fragment key={section.kind}>
                    {index > 0 ? <SearchComboboxDivider /> : null}
                    <SearchComboboxGroup
                        title={section.title}
                        labelId={combobox.getGroupLabelId(section.kind)}
                        action={
                            section.action
                                ? {label: section.action.label, ...combobox.getOptionProps(section.action.id), dataTestId: PRICES_SEARCH_TEST_IDS.RECENT_CLEAR}
                                : undefined
                        }
                        dataTestId={PRICES_SEARCH_TEST_IDS.GROUP}
                    >
                        {section.items.map((item) => {
                            const {recentId} = item;

                            return (
                                <Fragment key={item.id}>
                                    <PricesSearchRow
                                        item={item}
                                        optionProps={combobox.getOptionProps(item.id)}
                                        mode={mode}
                                        onRemove={recentId === undefined ? undefined : () => onRemoveRecent(recentId)}
                                    />
                                    {item.kind === "street" ? <PricesSearchStreetNumbers {...props} street={item} /> : null}
                                </Fragment>
                            );
                        })}
                        {section.showMore ? (
                            <SearchComboboxShowMore
                                {...combobox.getOptionProps(section.showMore.id)}
                                label={section.showMore.label}
                                isLoading={section.showMore.isLoading}
                                dataTestId={PRICES_SEARCH_TEST_IDS.SHOW_MORE}
                            />
                        ) : null}
                    </SearchComboboxGroup>
                </Fragment>
            ))}
        </>
    );
};
